export default "__VITE_ASSET___9Abt8DM__"